/** Service API pour le module Trésorerie. */
import api from './api';
import type {
  CompteBancaire,
  OperationBancaire,
  RapprochementBancaire,
  PositionTresorerie,
  FluxAttente,
} from '../types/tresorerie';

const BASE = '/tresorerie';

const list = <T,>(d: T[] | { results: T[] }): T[] => (Array.isArray(d) ? d : d.results);

export const tresorerieApi = {
  // ---- Comptes ----
  getComptes: () =>
    api.get<CompteBancaire[] | { results: CompteBancaire[] }>(`${BASE}/comptes/`).then(r => list(r.data)),

  createCompte: (data: Partial<CompteBancaire>) =>
    api.post<CompteBancaire>(`${BASE}/comptes/`, data).then(r => r.data),

  updateCompte: (id: number, data: Partial<CompteBancaire>) =>
    api.patch<CompteBancaire>(`${BASE}/comptes/${id}/`, data).then(r => r.data),

  deleteCompte: (id: number) => api.delete(`${BASE}/comptes/${id}/`),

  getPosition: () =>
    api.get<PositionTresorerie>(`${BASE}/comptes/position/`).then(r => r.data),

  depotEspeces: (compteId: number, montant: number, reference?: string) =>
    api.post(`${BASE}/comptes/${compteId}/depot_especes/`, { montant, reference }).then(r => r.data),

  // ---- Opérations ----
  getOperations: (params?: { compte?: number; rapproche?: boolean; sens?: string }) =>
    api.get<OperationBancaire[] | { results: OperationBancaire[] }>(`${BASE}/operations/`, { params })
      .then(r => list(r.data)),

  createOperation: (data: Partial<OperationBancaire>) =>
    api.post<OperationBancaire>(`${BASE}/operations/`, data).then(r => r.data),

  pointerOperation: (id: number) =>
    api.post<OperationBancaire>(`${BASE}/operations/${id}/pointer/`).then(r => r.data),

  getFluxAttente: () =>
    api.get<FluxAttente>(`${BASE}/operations/flux_attente/`).then(r => r.data),

  // ---- Rapprochements ----
  getRapprochements: (compteId?: number) =>
    api.get<RapprochementBancaire[] | { results: RapprochementBancaire[] }>(`${BASE}/rapprochements/`, {
      params: compteId ? { compte: compteId } : {},
    }).then(r => list(r.data)),

  createRapprochement: (data: { compte: number; date_fin: string; solde_releve: number; notes?: string }) =>
    api.post<RapprochementBancaire>(`${BASE}/rapprochements/`, data).then(r => r.data),

  validerRapprochement: (id: number) =>
    api.post<RapprochementBancaire>(`${BASE}/rapprochements/${id}/valider/`).then(r => r.data),
};
